import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, Subject, ReplaySubject, tap } from 'rxjs';
import { ConversationModel, ParticipantModel } from '../models/conversation.model';
import { MessageModel, MessagePost } from '../models/message.model';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  conversationController = '/api/Conversation';

  private conversationsData$ = new ReplaySubject<ConversationModel>(1);
  private previousTimestampKey = 'previousTimestamp';
  private isMessageReadKey = 'isMessageRead';

	constructor(private _http: HttpClient) 
  {
  }

  private get previousTimestamp(): number | null {
    const timestamp = localStorage.getItem(this.previousTimestampKey);
    return timestamp ? parseInt(timestamp, 10) : null;
  }

  private set previousTimestamp(value: number | null) {
    if(value !== null) {
      localStorage.setItem(this.previousTimestampKey, value.toString());
    } else {
      localStorage.removeItem(this.previousTimestampKey);
    }
  }

  private get isMessageRead(): boolean {
    const value = localStorage.getItem(this.isMessageReadKey);
    return value === 'true';
  }

  private set isMessageRead(value: boolean) {
    localStorage.setItem(this.isMessageReadKey, value.toString());
  }

  getConversationData(): Observable<ConversationModel> {
    // return the subject here
    // subscribers will be notified when the data is refreshed
    return this.conversationsData$.asObservable();
  }

  refreshConversationData(): Observable<ConversationModel> {
    return this._http.get<ConversationModel>(`${this.conversationController}`)
      .pipe(tap(response => {
        // notify all subscribers of new data
        this.conversationsData$.next(response);
      }));
  }

  // checkForNewMessage(): Observable<boolean> {
  //   return this._http.get<ConversationModel>(`${this.conversationController}`)
  //     .pipe(map(response => {
  //       const latestMessage = response.messages.reduce((prev, current) => {
  //         return prev.modified > current.modified ? prev : current
  //       });
  //       const newTimestamp = latestMessage.modified;
  //       const isNewMessage = this.previousTimestamp === null || newTimestamp > this.previousTimestamp;
  //       if(isNewMessage && latestMessage.userId !== response.studentUserId) {
  //         this.isMessageRead = false;
  //       }
  //       this.previousTimestamp = newTimestamp;
  //         return isNewMessage;
  //     }))
  // }

  markMessageAsRead(): void {
    this.isMessageRead = true;
  }

  getUnreadMessageStatus(): boolean {
    return !this.isMessageRead;
  }

  getConversation() {
    return this._http
              .get<ConversationModel>(`${this.conversationController}`)
  }

  getParticipant(id: number): Observable<ParticipantModel> {
    return this._http
              .get<ParticipantModel>(`${this.conversationController}/participant/${id}`)
  }

  getAvatarBase64(id: number): Observable<string> {
    return this._http
              .get<string>(`${this.conversationController}/participant/avatar/base64/${id}`)
  }
  getAvatarImage(id: number): Observable<string> {
    return this._http
              .get<string>(`${this.conversationController}/participant/avatar/image/${id}`)
  }

  sendMessage(message: any): Observable<MessagePost> {
    return this._http.post<MessagePost>(`${this.conversationController}/message`, message)
  }

  getAsset(id: number): Observable<Blob> {
    return this._http
    .get(`${this.conversationController}/message/asset/${id}`, {responseType: 'blob'})
  }

}
